import CustomerProjectPagingResultModelBase from '../_generated/modelBases/customer-project-paging-result-model-base';

export default class CustomerProjectPagingResultModel extends CustomerProjectPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
